import { Text, HStack, Box, Button, Grid, GridItem } from '@chakra-ui/react';
import { useRewardPrograms } from 'store/zustand/useRewardPrograms';
import { FaCaretDown } from 'react-icons/fa';
import { useModal } from 'store/modals';
import { ModalType } from 'components/modals/types';
import { useEffect, useState } from 'react';
import { fetchBlockTimestamp } from 'api/blockchain/blockTimestamp';
import { useWeb3React } from 'hooks/web3';
import { usePrograms } from 'hooks/query/usePrograms';
import { useCruciblesLocks } from 'hooks/query/useCrucibles';
import { useSelectedCrucible } from 'store/selectedCrucible';
import { Crucible } from 'types';

type Props = {
  crucible?: Crucible;
  isReadOnly: boolean;
  isLeaderboard?: boolean;
};

const RewardProgramSelector: React.FC<Props> = ({
  crucible,
  isReadOnly,
  isLeaderboard
}) => {
  const { chainId = 1 } = useWeb3React();
  const { currentRewardProgram } = useRewardPrograms();
  const { selectedCrucible } = useSelectedCrucible();
  const { data: extendedRewardPrograms } = usePrograms();
  const { data: crucibleLocks } = useCruciblesLocks(crucible);
  const { openModal } = useModal();
  const [blockTimestamp, setBlockTimestamp] = useState<number | null>(null);

  useEffect(() => {
    fetchBlockTimestamp(chainId).then((ts) => setBlockTimestamp(ts));
  }, [chainId]);

  return (
    <Button
      width='100%'
      py={[4, 2]}
      height='auto'
      color='white'
      variant='outline'
      borderWidth={1}
      borderRadius='xl'
      borderColor='cyan.400'
      role='button'
      disabled={
        !extendedRewardPrograms ||
        (!isLeaderboard && !crucibleLocks) ||
        !blockTimestamp
      }
      onClick={() =>
        openModal(ModalType.selectProgram, {
          blockTimestamp,
          extendedRewardPrograms: extendedRewardPrograms!,
          crucibleLocks: crucibleLocks!,
          selectedCrucible: selectedCrucible!,
          isReadOnly: isReadOnly,
          isLeaderboard
        })
      }
    >
      <Grid
        width='100%'
        direction={['column', 'row']}
        templateColumns={['repeat(1, 1fr)', 'auto auto']}
        alignItems={['flex-start', 'center']}
        rowGap={'2'}
      >
        <GridItem colSpan={[1, 1]} align='left' isTruncated>
          <Text
            isTruncated
            fontWeight='600'
            maxW={'100%'}
            verticalAlign='middle'
          >
            {currentRewardProgram.name} Reward Program
          </Text>
        </GridItem>
        <GridItem colSpan={[1, 1]} align='right'>
          <HStack maxWidth='fit-content'>
            <Text
              bg='whiteAlpha.200'
              borderRadius='xl'
              py={2}
              px={3}
              color='cyan.500'
              fontSize='xs'
              isTruncated
            >
              {currentRewardProgram.shortName}
            </Text>
            <Box
              bg={['whiteAlpha.200', 'none']}
              p={[2, 0]}
              borderRadius='xl'
              maxWidth={'fit-content'}
              minWidth='fit-content'
            >
              <FaCaretDown />
            </Box>
          </HStack>
        </GridItem>
      </Grid>
    </Button>
  );
};

export default RewardProgramSelector;
